import React from "react";
import CertificatesList from "@/components/student/CertificatesList";

export default function CertificatesPage() {
  return <CertificatesList />;
}
